import { ChangeDetectorRef, Component } from '@angular/core';
import { HeaderComponent } from '../../../../layout/header/header.component';
import { NavbarComponent } from '../../../../layout/navbar/navbar.component';
import { SidebarComponent } from '../../../../layout/sidebar/sidebar.component';
import { RoutelinksService } from '../../../../services/core/routelinks.service';
import { LanguageService } from '../../../../services/language.service';
import { LangChangeEvent, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { LanguageRequest } from '../../../../models/languageRequest';
import { LanguageDto } from '../../../../models/languagedto';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LanguageResponse } from '../../../../models/languageResponse';
import { PaginatorComponent } from '../../../../components/paginator/paginator.component';
import { SharedService } from '../../../../services/shared.service';
import { Subscription } from 'rxjs';
import { AlertComponentComponent } from "../../../../components/alert/alert-component.component";
import { messageVisibility } from '../../../../models/messageVisibility.model';

@Component({
  selector: 'app-languages',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent, TranslatePipe, CommonModule, ReactiveFormsModule, PaginatorComponent, AlertComponentComponent],
  templateUrl: './languages.component.html',
  styleUrl: './languages.component.css'
})
export class LanguagesComponent {

  links: any[] = []; // Lista de links para el sidebar

  selectedRowId: string | '' = '';

  languageRequest: LanguageRequest = new LanguageRequest();

  languageResponse: LanguageResponse = new LanguageResponse();

  createLanguage: boolean = false;

  updateLanguage: boolean = false;

  validateLanguageForm!: FormGroup;

  langChangeSubscription!: Subscription;

  messageVisibility: messageVisibility = new messageVisibility()

  errorMessage: string = '';

  constructor(private routelinks: RoutelinksService,
    private languageService: LanguageService,
    private changeDetector: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private sharedService: SharedService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.links = this.routelinks.linksAdministration; // Inicializa la propiedad en ngOnInit
    this.getLanguages(true);
    this.selectedRowId = '';
    this.initFormReactiveLanguage();

    // Servicio encargado de escuchar cuando se cambia de página
    this.sharedService.numberPageEventEmitter.subscribe((page: number) => {
      this.languageResponse.pageDto.currentPage = page;
      this.getLanguages(false);
    });

    // Servicio encargado de escuchar cuando se realiza el cambio idioma de la aplicacion
    this.langChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.changeDetector.detectChanges();
      this.getLanguages(true);
    });

  }

  private initFormReactiveLanguage(): void {
    this.validateLanguageForm = this.formBuilder.group({
      idLanguage: [''],
      code: ['', [Validators.required]],
      name: ['', [Validators.required]],
      isDefault: new FormControl(true),
      active: new FormControl(true)
    });
  }

  /**
   * Lista todos los lenguajes de la aplicación
   * @param init 
   */
  getLanguages(init: boolean) {
    if (!init) {
      this.languageRequest.pageRequest.page = this.languageResponse.pageDto.currentPage;
    }
    this.languageService.getAllLanguage(this.languageRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          this.languageResponse.languageDto = response.languageDto.map((lan: any) => {
            return {
              ...lan,
              code: lan.code?.toUpperCase()
            };
          });
          if (response.pageDto !== undefined) {
            this.languageResponse.pageDto = response.pageDto;
          }
        }
      }, error: error => {
        console.log(error);
      }
    })
  }

  /**
    * Función encargada de crear o actualizar un lenguaje
    */
  createOrUpdateLanguage(): void {
    this.languageRequest.languageDto = this.validateLanguageForm.value;
    this.languageRequest.languageDto.code = this.languageRequest.languageDto.code?.toLowerCase();
    if (this.createLanguage) {
      this.languageService.createLanguage(this.languageRequest.languageDto).subscribe({
        next: () => {
          this.messageVisibility.isErrorFirts = false;
          this.messageVisibility.isSuccessFirst = true;
          this.errorMessage = "S'ha creat correctament"
          this.getLanguages(true)
          this.resetValues();
        }, error: error => {
          this.messageVisibility.isErrorFirts = true;
          this.messageVisibility.isSuccessFirst = false;
          this.errorMessage = error.error.message
          console.log(error);
        }
      });
    } else {
      this.languageService.updateLanguage(this.languageRequest.languageDto).subscribe({
        next: () => {
          this.messageVisibility.isErrorFirts = false;
          this.messageVisibility.isSuccessFirst = true;
          this.errorMessage = "S'ha editat correctament"
          this.getLanguages(true)

        }, error: error => {
          this.messageVisibility.isErrorFirts = true;
          this.messageVisibility.isSuccessFirst = false;
          this.errorMessage = error.error.message
        }
      });
    }
  }


  checkRow(language?: LanguageDto): void {
    if (language) {
      if (this.selectedRowId === language.code) {
        this.selectedRowId = '';
        return;
      }
      // Modo edición
      this.selectedRowId = language.code || '';
      this.updateLanguage = true;
      this.createLanguage = false;
      this.validateLanguageForm.patchValue({
        idLanguage: language.idLanguage,
        code: language.code,
        name: language.name,
        isDefault: language.isDefault,
        active: language.active
      });

    } else {
      // Modo creación
      this.selectedRowId = '';
      this.updateLanguage = false;
      this.createLanguage = true;
      this.validateLanguageForm.reset();
      this.validateLanguageForm.patchValue({
        isDefault: false,
        active: true
      });
    }
    window.scrollTo(0, 600);
    this.changeDetector.detectChanges();
  }

  /**
   * Función encargada de elminar un lenguge por su id
   */
  deleteLangugeById(): void {
    this.languageService.deleteLanguage(this.validateLanguageForm.value.idLanguage,
      this.validateLanguageForm.value.isDefault).subscribe({
        next: () => {
          this.resetValues();
        }, error: error => {
          console.log(error);
        }
      })
  }

  /**
   * Reseta los valores del formulario
   */
  private resetValues() {
    this.getLanguages(true);
    this.validateLanguageForm.reset();
    this.selectedRowId = '';
  }


}
